export default {
  // Elpris-sammenligning
  didYouKnow: 'Vidste du?',
  didYouKnowText: 'Med enkel energi betaler du altid den rene spotpris uden tillæg – så du automatisk får gavn af de billigste timer.',
  heroTitle: 'Sammenlign elpriser og find det bedste elselskab',
  heroText1: 'Sammenlign elselskaber og se hvor meget du kan spare ved at skifte til enkel energi. Vores sammenligning af elpriser viser dig præcis, hvor billig strøm kan være med den rigtige el-leverandør.',
  heroBanner: 'Valg af elselskab er vigtigt – vi giver dig spotpris uden tillæg og et af markedets laveste abonnementer.',
  calculateSavings: 'Beregn besparelse',
  whyBestTitle: 'Derfor er enkel blandt de bedste elselskaber',
  whyBestSubtitle: 'Ved valg af elleverandør skal du se på mere end bare pris. Hos enkel får du fordelagtige abonnementer, god service og smart teknologi i ét.',
  cheapestTitle: 'Spotpris uden tillæg',
  cheapestText: 'Få strøm til spotpris uden tillæg.',
  smartChargeIncluded: 'Saving Mode inkluderet',
  smartChargeIncludedText: 'Få automatisk optimering af din opladning med vores Saving Mode - inkluderet i prisen.',
  switchMinutes: 'Skift elselskab på 2 minutter',
  switchMinutesText: 'Vi håndterer hele skiftet fra dit gamle energiselskab - du behøver ikke at gøre noget.',
  guideTitle: 'Guide til valg af elselskab',
  guide1Title: '1. Sammenlign elpriser og abonnementer',
  guide1Text: 'Når du sammenligner elselskaber, skal du se på både spotprisen og abonnementet. Mange eludbydere lokker med lave priser, men har høje abonnementsgebyrer. Hos enkel får du et af markedets laveste abonnementer kombineret med spotpris uden tillæg.',
  guide2Title: '2. Tjek den samlede pris',
  guide2Text: 'Mange elforsyningsselskaber har tillæg ovenpå spotprisen eller høje abonnementer. Ved sammenligning af elpriser er det vigtigt at se den samlede pris. Hos enkel giver dig spotprisen 1:1 med et af markedets laveste abonnementer.',
  guide3Title: '3. Vælg et elselskab med god service',
  guide3Text: 'Det bedste elselskab er ikke kun det billigste – service er også vigtig. Læs anmeldelser på Trustpilot og andre platforme for at se, hvilke el leverandører andre kunder anbefaler. Enkel har gode anmeldelser på ELBIIL.dk og Stromligning.dk med høje ratings for service.',
  guide4Title: '4. Se på bindingsperiode og fleksibilitet',
  guide4Text: 'Ved valg af energiselskab skal du tjekke bindingsperioden. Hos enkel har vi ingen binding – du kan skifte el-aftale eller elleverandør når som helst. Det giver dig fuld fleksibilitet.',
  chooseElPlan: 'Vælg din el-aftale',
  getBestPrices: 'Få konkurrencedygtige priser med enkel energi',
  mostPopular: 'Mest populær',
  elPlansSharpPrices: 'El-aftaler til skarpe priser',
  bestPricesNoMarkup: 'Få konkurrencedygtige elpriser uden tillæg til spotprisen',
  priceFrom: 'Pris fra',
  avgPriceNote: 'Sidste måneds gennemsnitspris inkl. abonnement (baseret på et forbrug på 6.000 kWh/år)',
  noSpotMarkup: 'Ingen tillæg til spotprisen',
  noSpotMarkupDesc: '100% børsnoterede priser – ingen tillæg',
  flexibleSmartCharge: 'Fleksibel Saving Mode',
  flexibleSmartChargeDesc: 'App der optimerer din ladning automatisk',
  switchEasy: 'Skift nemt på 2 minutter',
  switchEasyDesc: 'Vi håndterer alt papirarbejde med dit gamle elselskab',
  cheapestSubscription: 'Et af markedets laveste abonnementer',
  cheapestSubscriptionDesc: 'Fra kun 18 kr./måned - inkluderet i prisen ovenfor',
  seeElPlans: 'Se el-aftaler',
  chargerPlusEl: 'Ladeboks + el-aftale i én pakke',
  completePackage: 'Komplet pakke',
  completeChargingSolution: 'Komplet ladeløsning med strøm til skarpeste pris',
  optionalInstallation: 'Valgfri installation',
  optionalInstallationDesc: 'Tilkøb professionel installation eller montering',
  smartChargeFromDayOne: 'Saving Mode fra dag ét',
  smartChargeFromDayOneDesc: 'Din ladeboks er klar til intelligent ladning fra start',
  allLeadingBrands: 'Alle førende mærker',
  allLeadingBrandsDesc: 'Vælg mellem Zaptec Go, Zaptec Go 2 og NexBlue Edge 2',
  elPlanSharpPrices: 'El-aftale med skarpe priser',
  elPlanSharpPricesDesc: 'Samme lave elpriser som vores standard el-aftaler',
  seeChargingPackages: 'Se ladepakker',
  
  // Pris-time-for-time
  priceHeroTitle: 'Forstå strømprisen – time for time og kvarter for kvarter',
  priceHeroText1: 'I Danmark bestemmes strømprisen ikke af elselskaberne – den bliver handlet på et åbent elmarked kaldet elspotbørsen. Prisen opdateres time for time, men med 15-minutters afregning kan du få endnu mere præcis afregning og større besparelser.',
  priceHeroText2: 'Hvis du vælger en elaftale med spotpris, betaler du den samme pris som alle andre i dit område – uden tillæg eller skjulte omkostninger. Med 15-minutters afregning får du endnu mere præcis afregning.',
  priceHeroBanner: 'Hos enkel får du altid den rene strømpris – præcis som den handles på elmarkedet. Vælg mellem time-afregning eller 15-minutters afregning for endnu større besparelser.',
  howElPriceWorks: 'Hvordan fungerer elprisen i Danmark?',
  howElPriceText1: 'Strøm i Danmark bliver købt og solgt på elbørsen Nord Pool. Her fastsættes prisen ud fra udbud og efterspørgsel – præcis som på en rigtig børs. Standard er time-afregning, men du kan også vælge 15-minutters afregning for større præcision.',
  howElPriceText2: 'Mange danskere ved ikke, at dette er standard for hele landet, og derfor kan spotpris virke uklart eller utrygt. I virkeligheden er det den mest gennemsigtige og fair model, fordi industrien, virksomheder og private alle betaler efter samme grundlæggende markedspris.',
  priceComposition: 'Hvad består din elpris af?',
  priceCompositionIntro: 'Når du bruger strøm, består prisen af fire dele:',
  spotPrice: 'Spotprisen',
  spotPriceDesc: 'Den pris strømmen handles til på elbørsen',
  gridTariffs: 'Tariffer til dit netselskab',
  gridTariffsDesc: 'Afhænger af hvor du bor',
  elTax: 'Elafgift',
  elTaxDesc: 'Statens afgift',
  vat: 'Moms',
  vatDesc: '25% af den samlede pris',
  spotPriceSameForAll: 'Kun spotprisen er ens for alle',
  restDependsOnLocation: '– resten afhænger af hvor du bor og dit lokale netselskab.',
  dk1dk2Title: 'DK1 og DK2 – hvorfor prisområder?',
  dk1dk2Intro: 'Danmark er opdelt i:',
  dk1: 'DK1 (Vest)',
  dk1Desc: 'Jylland og Fyn',
  dk2: 'DK2 (Øst)',
  dk2Desc: 'Sjælland, Lolland-Falster og Bornholm',
  dk1dk2Note: 'Områderne kan have forskellige priser, fordi mængden af vind, sol, kabelforbindelser og import/eksport varierer.',
  howToUseGraph: 'Sådan bruger du grafen',
  howToUseGraphIntro: 'Under grafen kan du:',
  howToUseGraph1: 'vælge din region (DK1 eller DK2)',
  howToUseGraph2: 'vælge dit netselskab',
  howToUseGraph3: 'skifte mellem ren spotpris eller pris inkl. tariffer, afgifter og moms',
  howToUseGraph4: 'se prisudviklingen time for time eller kvarter for kvarter (med 15-min afregning)',
  pricesUpdatedDaily: 'Priserne opdateres én gang i døgnet.',
  didDuKnow: 'Vidste du?',
  didDuKnowText: 'Næsten alle danskere tror deres elselskab bestemmer strømprisen – men i virkeligheden kommer prisen fra elbørsen. Med 15-minutters afregning kan du spare endnu mere!',
  dataProvidedBy: 'Data leveret af',
  
  // Kan-alle-faa-stroem
  canAllGetTitle: 'Kan alle få strøm fra enkel?',
  canAllGetSubtitle: 'Ja – vi leverer til alle danske husstande, uanset om du har elbil eller ej',
  canAllGetIntro1: 'Ja, alle danske husstande kan få strøm fra enkel energi.',
  canAllGetIntro2: 'Vi leverer el i hele Danmark – fra Skagen til Gedser, fra København til Esbjerg. Det er lige meget, hvor du bor, eller om du har en elbil eller ej.',
  canAllGetIntro3: 'Vi håndterer hele skiftet fra dit nuværende elselskab. Bemærk dog, at nogle elselskaber kan have opsigelsesperioder eller binding.',
  nationwideDelivery: 'Landsdækkende levering',
  nationwideDeliveryDesc: 'Vi leverer el til hele Danmark',
  regionCapital: 'Region Hovedstaden',
  regionCapitalDesc: 'København, Frederiksberg, Gentofte, Lyngby-Taarbæk, og alle andre kommuner i hovedstadsområdet',
  regionZealand: 'Region Sjælland',
  regionZealandDesc: 'Roskilde, Køge, Næstved, Slagelse, Holbæk, og resten af Sjælland',
  regionSouth: 'Region Syddanmark',
  regionSouthDesc: 'Odense, Esbjerg, Kolding, Vejle, Sønderborg, og hele syden',
  regionMid: 'Region Midtjylland',
  regionMidDesc: 'Aarhus, Herning, Viborg, Randers, Silkeborg, og midtjylland',
  regionNorth: 'Region Nordjylland',
  regionNorthDesc: 'Aalborg, Hjørring, Frederikshavn, Thisted, og nordjylland',
  islands: 'Øerne',
  islandsDesc: 'Bornholm, Læsø, Samsø, Ærø, Fanø, og alle andre danske øer',
  whoCanBeCustomer: 'Hvem kan blive kunde hos enkel?',
  privateHouseholds: 'Private husstande',
  privateHouseholdsDesc: 'Alle private husstande i Danmark kan få strøm fra enkel. Det gælder både parcelhuse, rækkehuse, lejligheder, og mange andre boligtyper. Du skal blot have din egen elmåler.',
  evOwners: 'Elbilsejere',
  evOwnersDesc: 'Hvis du har en elbil, får du adgang til vores Saving Mode-løsning, der automatisk optimerer din opladning til de billigste tidspunkter.',
  noEv: 'Uden elbil?',
  noEvDesc: 'Du behøver ikke have en elbil for at blive kunde hos enkel. Mange vælger os på grund af vores gennemsigtige priser og gode kundeservice – helt uanset om de har elbil eller ej.',
  whatYouNeedTitle: 'Hvad skal du bruge for at tilmelde dig?',
  whatYouNeed: 'Hvad skal du bruge for at skifte?',
  whatDuNeed: 'Hvad skal du bruge for at skifte?',
  basicInfo: 'Dine basisoplysninger',
  basicInfoDesc: 'Vi finder automatisk dine oplysninger ud fra din adresse',
  durAddress: 'Din adresse',
  yourAddress: 'Din adresse',
  durAddressDesc: 'Hvor strømmen skal leveres',
  yourAddressDesc: 'Hvor strømmen skal leveres',
  contactInfo: 'Dine kontaktoplysninger',
  contactInfoDesc: 'Navn, email, og telefonnummer',
  switchDate: 'Ønsket skiftedato (valgfrit)',
  switchDateDesc: 'Hvis du har en bestemt dato, du ønsker at skifte fra',
  requiredInfo: 'Påkrævede oplysninger',
  emailAndPhone: 'Email og telefonnummer',
  cprVerification: 'CPR-nummer (til verifikation)',
  optionalInfo: 'Valgfrie oplysninger',
  desiredSwitchDate: 'Ønsket skiftedato',
  estimatedConsumption: 'Estimeret årsforbrug',
  evChargerInfo: 'Info om elbil og ladeboks',
  switchNote: 'Vi håndterer hele skiftet. Dit el-forbrug vil fortsætte uden afbrydelse. Husk dog at tjekke om dit nuværende elselskab har opsigelsesperioder eller binding.',
  howToSwitch: 'Sådan skifter du til enkel',
  step1SignUp: 'Tilmeld dig online',
  step1SignUpDesc: 'Udfyld formularen med dine oplysninger – det tager kun 2 minutter',
  step2HandleSwitch: 'Vi håndterer skiftet',
  step2HandleSwitchDesc: 'Dit nuværende elselskab bliver kontaktet og en smidig overgang sikres',
  step3Ready: 'Du er klar',
  step3ReadyDesc: 'Din nye aftale aktiveres',
  specialSituations: 'Særlige situationer',
  dormQ: 'Jeg er på kollegium – kan jeg skifte?',
  dormA: 'Hvis du har din egen elmåler, kan du skifte til enkel. Hvis du deler elmåler med mange andre, er det desværre ikke muligt, da det er ejeren af måleren, der skal skifte elselskab.',
  renterQ: 'Jeg lejer min bolig – kan jeg skifte?',
  renterA: 'I praksis skal det være udlejer, der skifter elselskab. Kontakt din udlejer, hvis du ønsker at skifte til enkel energi.',
  movingQ: 'Jeg flytter – kan jeg tage enkel med?',
  movingA: 'Ja, du kan sagtens tage din enkel-aftale med til din nye adresse. Kontakt os bare, så opdaterer vi din adresse og målernummer.',
  summerHouseQ: 'Jeg har et sommerhus – kan jeg få enkel der også?',
  summerHouseA: 'Ja, du kan have enkel til både din hovedbolig og dit sommerhus. Hvis du har flere adresser, kan du have en aftale på hver.',
  readyToSwitch: 'Klar til at skifte?',
  readyToSwitchDesc: 'Det tager kun 2 minutter at tilmelde sig – og vi håndterer resten',
  switchNow: 'Skift til enkel nu',
  relatedQuestions: 'Relaterede spørgsmål',
  whatDoesItCost: 'Hvad koster det at få el gennem enkel?',
  seePrices: 'Se vores priser og abonnementer',
  breadcrumbHome: 'Forside',
  breadcrumbComparePrices: 'Sammenlign Priser',
  breadcrumbElPrices: 'Strømpriser',
  breadcrumbCanAll: 'Kan alle få strøm fra enkel?',
};